/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React from 'react';

import './BlogDesktop.scss';

export default function BlogDesktop({ blogs }) {
    return (
        <div className="DesktopBlog">
            { blogs.map((blog) => (
                <div
                  key={ blog.id }
                  className="DesktopBlog-Left"
                  onClick={ () => {
                      window.open(blog.url);
                  } }
                >
                    <img className="Img" src={ blog.image } alt="Snow" />
                    <h1 className="Name">{ blog.title }</h1>
                    <div className="Container">
                        <p className="Date">{ blog.date }</p>
                        <div className="Link">
                            Read more
                        </div>
                    </div>
                </div>
            )) }
        </div>
    );
}
